// src/components/sacred/ZelligeBackdrop.jsx
// Fixed full-screen zellige tile layer behind everything at 5% opacity.

import React from 'react';
import { Box } from '@mui/material';

const ZelligeBackdrop = () => (
  <Box
    className="medersa-pattern"
    aria-hidden
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: -1,
      pointerEvents: 'none',
      backgroundSize: '400px',
    }}
  />
);

export default ZelligeBackdrop;
